import {
  EnumAlarmType,
  EnumNotificationType,
  EnumTempDeterminer,
} from "../../redux/interfaces";

export const KatalogEvidencijaResourcesEN: KatalogEvidencijaResourcesBSInterface =
  {
    deleteModal: {
      title: "Delete evidence",
      text: "Do you want to delete this evidence?",
      buttonYes: "Delete",
      buttonNo: "Back",
    },
    deleteSuccessModal: {
      title: "Deleted successfully",
      body: "The evidence was deleted successfully.",
      buttonOk: "OK",
    },
    deleteErrorModal: {
      title: "Delete failed",
      body: "An error occurred while deleting the evidence. Please try again or contact the administrator.",
      buttonOk: "OK",
    },
    checklistConfig: {
      title: "Checklist configuration",
      rowLabel: "Checklist configuration",
      rowPlaceholder: "Define checklist item names",
      fieldLabelPrefix: "Item name #",
      checkedByDefaultLabel: "Check by default",
      addButton: "Add item",
      removeButton: "Remove",
      buttons: {
        save: "Save",
        back: "Back",
      },
      errors: {
        load: "Error while loading.",
        save: "Error while saving.",
      },
    },
    errors: {
      poslovnica: "Please select a branch.",
      katalogEvidencijaBranches:
        "Error during loading. Please contact the administrator.",
      deleteError:
        "An error occurred while deleting the configuration. Please contact the administrator.",
    },
    successModal: {
      title: "Data Entry",
      body: "Data addition has been successfully completed. Select OK to continue.",
      buttonOk: "OK",
    },
    editDescription: {
      title: "Description Processing",
    },
    addButton: "Add New",
    evidencijePlaceholder: "No evidence found",
    evidencijeOdabirPoslovnice: "Select branch",
    typeEvidencije: {
      occasionally: "As Needed",
      redovna: "Regular",
      placeholder: "Please select a category",
    },
    vrsteEvidencije: {
      evidencija: "Evidence",
      template: "Template",
    },
    evidencijaForm: {
      title: "Evidence Catalog Form",
      markdownContent: {
        name: "markdownContent",
        error: "Error Markdown Content",
        label: "Detailed Description",
        placeholder: "",
      },
      branch: {
        label: "Select branch",
        placeholder: "Select branch",
        noOptions: "No branches found",
        name: "branch",
        error: "",
      },
      typeList: {
        label: "Select category",
        placeholder: "Select category",
        noOptions: "No categories found",
        name: "typeList",
        error: "",
      },
      revizija: {
        label: "Revision",
        placeholder: "Add revision version",
        name: "revizija",
        error: "Add revision version",
      },
      description: {
        label: "Description",
        placeholder: "Add description",
        name: "description",
        error: "Add description",
      },
      titleForm: {
        label: "Evidence name",
        placeholder: "Add evidence name",
        name: "title",
        error: "Add evidence name",
      },
      category: {
        label: "Select evidence type",
        placeholder: "Select type",
        noOptions: "No types found",
        name: "category",
        error: "",
      },
      buttonForward: "Add",
      buttonBack: "Back",
      successModal: {
        title: "Data Entry",
        body: "Data addition has been successfully completed. Select OK to continue.",
        buttonOk: "OK",
      },
    },
    autocompleteConfig: {
      title: "Automatic Filling Configuration",
      enabled: {
        label: "Enable automatic filling",
        name: "enabled",
      },
      signerType: {
        label: "Signer type",
        name: "signerType",
        options: {
          user: "Specific user",
          position: "Position/Role",
        },
        note: "Changing the signer type will only clear the current signer selection for autocomplete, but will not affect responsible persons.",
      },
      signer: {
        label: "Signer",
        name: "signer",
        placeholder: "Enter user ID or position",
      },
      fieldValues: {
        title: "Field values configuration",
        description:
          "Configure values for specific fields. Use semicolon (;) to separate multiple values for random selection.",
        fieldName: {
          label: "Field name",
          placeholder: "Select field",
        },
        values: {
          label: "Values (separate with ;)",
          placeholder: "value1; value2; value3",
        },
        addButton: "Add field value",
        removeButton: "Remove",
      },
      pointScope: {
        label: "Application point",
        allPoints: "All application points",
        hintAll:
          "These values apply to all application points, except those with a specific override.",
        hintPoint:
          "Values only for the selected application point. Other points use the “All application points” settings.",
        hasOverride: "Custom settings",
        clearOverride: "Reset to shared settings",
        noPoints:
          "No application points configured. Add them in the Application points step first.",
      },
      successModal: {
        title: "Success!",
        body: "Automatic filling configuration has been successfully saved.",
        buttonOk: "OK",
      },
      buttons: {
        save: "Save configuration",
        back: "Back",
      },
    },
    kreiranjeEvidencije: {
      errorMissingFields: "Please fill in all fields to activate the evidence.",
      errorCreation: "An error occurred. Please contact the administrator.",
      description: {
        label: "Descriptions",
        placeholder: "Enter description",
        name: "opis",
        error: "",
      },
      tempConfigPolja: {
        name: "tempConfig",
        label: "Temperature configuration",
        placeholder: "Please enter temperature configuration",
        title: "Temperature Configuration",
        dozvoljenaTempMin: {
          label: "Minimum allowed temperature",
          name: "dozvoljenaTempMin",
          placeholder: "Please enter minimum temperature",
        },
        dozvoljenaTempMax: {
          label: "Maximum allowed temperature",
          name: "dozvoljenaTempMax",
          placeholder: "Please enter maximum temperature",
        },
        dozvoljenoOdstupanje: {
          label: "Allowed deviation",
          name: "dozvoljenoOdstupanje",
          placeholder: "Please enter allowed deviation",
        },
      },
      status: {
        activate: "Activate",
        deactivate: "Deactivate",
        saveAs: "New version",
      },
      nazivEvidencije: {
        title: "Creating Evidence",
        label: "Evidence name",
        placeholder: "Add evidence name",
        name: "title",
        error: "Add evidence name",
      },
      revizija: {
        title: "Revision",
        label: "Revision",
        placeholder: "Add revision",
        name: "revizija",
        error: "Add revision",
      },
      tackePrimjene: {
        title: "Application points",
        label: "Application points",
        placeholder: "Select application points",
        name: "recordPoints",
        error: "No application point selected",
      },
      ucestalost: {
        title: "Recording Frequency",
        label: "Recording Frequency",
        placeholder: "Enter recording frequency",
        name: "frequency",
        error: "Recording frequency not selected",
        visegodisnje: {
          title: "Multi-year",
          btnVisegodisnje: "Multi-year",
          btnDatum: "Date",
        },
        godisnje: {
          title: "Yearly",
          btnGodisnje: "Yearly",
          btnDatum: "Date",
        },
        mjesecno: {
          title: "Monthly",
          btnMjesecno: "Monthly",
          btnDatumPocetak: "Start date",
          btnDatumKraj: "End date",
          btnBrojanje: "Start from",
          lblSvaki: "Every ",
          lblMjesec: "month",
        },
        sedmicno: {
          title: "Weekly",
          btnSedmicno: "Weekly",
          btnDatumPocetak: "Start date",
          btnDatumKraj: "End date",
          btnBrojanje: "Start from",
          lblSvake: "Every ",
          lblSedmice: "weeks",
          errorBeginDate: "Select a week (YYYY-Www) before saving.",
        },
        dnevno: {
          title: "Daily",
          btnDnevno: "Daily",
          btnPocetak: "Start",
          btnKraj: "End",
          btnBrojanje: "Start from",
          lblSvaki: "Every ",
          lblDan: "day",
          skipSaturday: "Skip Saturday",
          skipSunday: "Skip Sunday",
        },
        poPotrebi: {
          btnPoPotrebi: "As needed",
        },
      },
      odgovorneOsobe: {
        title: "Responsible Persons",
        label: "Responsible Persons",
        placeholder: "Select responsible persons",
        name: "dedicatedUsers",
        error: "No responsible person selected",
      },
      tpEvidencije: {
        title: "Application Points",
        back: "Back",
        next: "Save changes",
      },
      podsjetnik: {
        title: "Notifications",
        label: "Notifications",
        placeholder: "Configure notifications",
        name: "notifications",
        error: "Notifications not configured",
      },
      poljeEvidencije: {
        title: "Evidence Fields",
        label: "Evidence Fields",
        placeholder: "Select evidence fields",
        name: "poljeEvidencije",
        error: "Evidence fields not selected",
      },
      obavijesti: {
        title: "Notifications",
        cbNotifikacija: "On expiry - notification",
        plcPeriod: "Period",
        optPeriod: [
          {
            value: EnumTempDeterminer.MINUTA,
            label: "Minutes",
          },
          {
            value: EnumTempDeterminer.SATI,
            label: "Hours",
          },
          {
            value: EnumTempDeterminer.DANA,
            label: "Days",
          },
        ],
        plcKada: "Before/after",
        optKada: [
          {
            value: EnumAlarmType.beforeStart,
            label: "Before start",
          },
          {
            value: EnumAlarmType.afterStart,
            label: "After start",
          },
          {
            value: EnumAlarmType.beforeEnd,
            label: "Before end",
          },
          {
            value: EnumAlarmType.afterEnd,
            label: "After end",
          },
        ],
        plcKako: "Notification",
        optKako: [
          {
            value: EnumNotificationType.email1,
            label: "Email to assigned persons",
          },
          {
            value: EnumNotificationType.email2,
            label: "Email to managers",
          },
          {
            value: EnumNotificationType.email3,
            label: "Email to chiefs",
          },
          {
            value: EnumNotificationType.sms1,
            label: "SMS to assigned persons",
          },
          {
            value: EnumNotificationType.sms2,
            label: "SMS to managers",
          },
          {
            value: EnumNotificationType.sms3,
            label: "SMS to chiefs",
          },
          {
            value: EnumNotificationType.call1,
            label: "Call assigned persons",
          },
          {
            value: EnumNotificationType.call2,
            label: "Call managers",
          },
          {
            value: EnumNotificationType.call3,
            label: "Call chiefs",
          },
        ],
      },
      language: {
        title: "Language",
        label: "Language",
        placeholder: "Select language",
        name: "language",
        options: {
          bs: "Bosnian",
          en: "English",
          de: "German",
        },
      },
      manager: {
        label: "Manager",
        placeholder: "Select manager",
        notFound: "No users found",
      },
      isPublic: {
        title: "Public Access",
        label: "Evidence is public",
        description: "If checked, evidence will be publicly available",
      },
      notifyManagersOnFeedback: {
        title: "Notify managers",
        label: "Email managers when new feedback arrives",
        description:
          "If checked, branch managers receive an email each time new feedback is submitted",
      },
      qrCode: {
        button: "Generate QR Code",
        modalTitle: "Generate QR Code",
        selectLabel: "Select record point",
        selectPlaceholder: "Select record point...",
        generateButton: "Generate QR Code",
        downloadButton: "Download QR Code",
        cancelButton: "Cancel",
        noRecordPointsError: "No record points configured. Please configure record points first.",
        downloadError: "An error occurred while downloading the QR code. Please try again.",
      },
      details: {
        title: "Details",
        recordPointIds: "Record Point IDs",
        noRecordPoints: "Record points have not been generated yet",
      },
      buttonForward: "Forward",
      buttonBack: "Back",
      successModal: {
        title: "Data Entry",
        body: "Data addition has been successfully completed. Select OK to continue.",
        buttonOk: "OK",
      },
    },
    recordPointsConfig: {
      title: "Application Points Configuration",
      errorMissingFields: "Please fill in all fields to activate the evidence.",
      errorCreation: "An error occurred. Please contact the administrator.",
      recordPoints: {
        title: "Application Points",
        label: "Application Points",
        placeholder: "Enter application points",
        name: "recordPoints",
        error: "Application points not entered",
        addButton: "Add Point",
        removeButton: "Remove",
        selectedLabel: "Selected",
        notSelectedLabel: "Not Selected",
      },
      buttonForward: "Forward",
      buttonBack: "Back",
      successModal: {
        title: "Data Entry",
        body: "Data addition has been successfully completed. Select OK to continue.",
        buttonOk: "OK",
      },
    },
    frequencyConfig: {
      title: "Frequency Configuration",
      errorMissingFields: "Please fill in all fields to activate the evidence.",
      errorCreation: "An error occurred. Please contact the administrator.",
      frequency: {
        title: "Frequency",
        label: "Frequency",
        placeholder: "Enter frequency",
        name: "frequency",
        error: "Frequency not entered",
        addButton: "Add Frequency",
        removeButton: "Remove",
        typeLabel: "Type",
        startDateLabel: "Start Date",
        endDateLabel: "End Date",
        occurrenceLabel: "Occurrence",
        beginDateLabel: "Begin Date",
        types: {
          DNEVNI: "Daily",
          SEDMICNI: "Weekly",
          MJESECNI: "Monthly",
          GODISNJI: "Yearly",
          CUSTOM: "Custom",
        },
      },
      buttonForward: "Forward",
      buttonBack: "Back",
      successModal: {
        title: "Data Entry",
        body: "Data addition has been successfully completed. Select OK to continue.",
        buttonOk: "OK",
      },
    },
    usersConfig: {
      title: "Users Configuration",
      errorMissingFields: "Please fill in all fields to activate the evidence.",
      errorCreation: "An error occurred. Please contact the administrator.",
      users: {
        title: "Users",
        label: "Users",
        placeholder: "Enter users",
        name: "users",
        error: "Users not entered",
        addButton: "Add User",
        removeButton: "Remove",
        recordPointLabel: "User/Position",
        categoryLabel: "Is Position",
        categoryOptions: {
          user: "User",
          position: "Position",
        },
      },
      buttonForward: "Forward",
      buttonBack: "Back",
      successModal: {
        title: "Data Entry",
        body: "Data addition has been successfully completed. Select OK to continue.",
        buttonOk: "OK",
      },
    },
    notificationsConfig: {
      title: "Notifications Configuration",
      errorMissingFields: "Please fill in all fields to activate the evidence.",
      errorCreation: "An error occurred. Please contact the administrator.",
      notifications: {
        title: "Notifications",
        label: "Notifications",
        placeholder: "Configure notifications",
        name: "notifications",
        error: "Notifications not configured",
        defaultNotification: {
          label: "Default Notification",
          name: "defaultNotification",
        },
        addButton: "Add Notification",
        removeButton: "Remove",
        typeLabel: "Type",
        alarmTypeLabel: "Alarm Type",
        tempDeterminerLabel: "Temperature Determiner",
        countdownLabel: "Countdown",
        types: {
          [EnumNotificationType.email1]: "Email 1",
          [EnumNotificationType.email2]: "Email 2",
          [EnumNotificationType.email3]: "Email 3",
          [EnumNotificationType.sms1]: "SMS 1",
          [EnumNotificationType.sms2]: "SMS 2",
          [EnumNotificationType.sms3]: "SMS 3",
          [EnumNotificationType.call1]: "Call 1",
          [EnumNotificationType.call2]: "Call 2",
          [EnumNotificationType.call3]: "Call 3",
        },
        alarmTypes: {
          [EnumAlarmType.beforeStart]: "Before Start",
          [EnumAlarmType.afterStart]: "After Start",
          [EnumAlarmType.beforeEnd]: "Before End",
          [EnumAlarmType.afterEnd]: "After End",
        },
        tempDeterminers: {
          [EnumTempDeterminer.DANA]: "Days",
          [EnumTempDeterminer.MINUTA]: "Minutes",
          [EnumTempDeterminer.SATI]: "Hours",
        },
      },
      buttonForward: "Forward",
      buttonBack: "Back",
      successModal: {
        title: "Data Entry",
        body: "Data addition has been successfully completed. Select OK to continue.",
        buttonOk: "OK",
      },
    },
    evidenceFieldsConfig: {
      title: "Evidence Fields Configuration",
      errorMissingFields: "Please fill in all fields to activate the evidence.",
      errorCreation: "An error occurred. Please contact the administrator.",
      recordFields: {
        title: "Evidence Fields",
        label: "Evidence Fields",
        placeholder: "Select evidence fields",
        name: "recordFields",
        error: "Evidence fields not selected",
        options: {
          CIPP_V1: "Cleaning and Washing of Premises",
          CIPO_V1: "Cleaning and Washing of Equipment",
          TemperaturaEvd_V1: "Temperature Lists v1",
          TemperaturaOgranicenaEvd_V1: "Temperature Lists - Limited",
          TemperaturaOgranicenaKKTEvd_V1: "Temperature Lists - Limited KKT",
          TemperaturaKKTProizvodiEvd_V1:
            "Temperature Lists - Limited KKT Products",
          Dezinfekcija_V1: "Disinfection v1",
          Dezinsekcija_V1: "Disinsection v1",
          Deratizacija_V1: "Deratization v1",
        },
      },
      buttonForward: "Forward",
      buttonBack: "Back",
      successModal: {
        title: "Data Entry",
        body: "Data addition has been successfully completed. Select OK to continue.",
        buttonOk: "OK",
      },
    },
  };

export interface KatalogEvidencijaResourcesBSInterface {
  deleteModal: {
    title: string;
    text: string;
    buttonYes: string;
    buttonNo: string;
  };
  deleteSuccessModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  deleteErrorModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  errors: {
    poslovnica: string;
    katalogEvidencijaBranches: string;
    deleteError: string;
  };
  successModal: {
    title: string;
    body: string;
    buttonOk: string;
  };
  editDescription: {
    title: string;
  };
  addButton: string;
  evidencijePlaceholder: string;
  evidencijeOdabirPoslovnice: string;
  typeEvidencije: {
    occasionally: string;
    redovna: string;
    placeholder: string;
  };
  vrsteEvidencije: {
    evidencija: string;
    template: string;
  };
  evidencijaForm: any;
  autocompleteConfig: any;
  kreiranjeEvidencije: any;
  recordPointsConfig: any;
  frequencyConfig: any;
  usersConfig: any;
  notificationsConfig: any;
  evidenceFieldsConfig: any;
  checklistConfig: ChecklistConfig;
}

interface ChecklistConfig {
  title: string;
  rowLabel: string;
  rowPlaceholder: string;
  fieldLabelPrefix: string;
  checkedByDefaultLabel: string;
  addButton: string;
  removeButton: string;
  buttons: { save: string; back: string };
  errors: { load: string; save: string };
}
